import { Component, Vue, Provide } from 'vue-property-decorator';
import Axios from "../../plugins/http";

@Component
export default class PauseArea extends Vue {
    search:any = {
        province:'',
        city:'',
        district:'',
        // search:'',
        source:'', //1手动添加 2导入
        status:'', //0已禁用 1启用
        isValid:''
    }

    lastUpdateTime:string = '';
    tableData:any[] = [];
    pageNo:number = 1;
    pageSize:number = 20;
    total:number = 0;
    token:any = window.localStorage.getItem('token') || ''

    provinceList:any[] = [];
    cityList:any = [];
    districtList:any = [];
    options:any = [];
    isAdd:boolean = false;
    selectArea:any = [];
    isConfirm:boolean = false;
    addForm:any = {
        selectArea:[]
    }
    created() {
        this.getCityList()
        this.getList()
    } 
    onSearch(){
        this.pageNo = 1;
        this.getList();
    }
    onRest(){
        this.search = {
            // search:'',
            source:'', 
            status:'', 
            isValid:''
        }
        this.selectArea = [];
        this.pageNo = 1;
        this.getList();
    }
    onClear(){
        this.$confirm(`是否清空当前筛选数据？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
                let {
                    source,
                    status,
                    isValid
                } = this.search;
                let [province='',city='',district=''] = this.selectArea;
                let data = {
                    city,
                    province,
                    district,
                    source,
                    status,
                    isValid
                }
                Axios.postByJson('/api/stopArea/clearAll',data).then((res:any)=>{
                    if(res.data.status == 200){
                        this.getList();
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
          }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
          });
        
    }
    getCityList(){
        Axios.getSecret('/api/common/cascadingAreas').then((res:any)=>{
            if(res.data.status === 200){
                res.data.data.map((item:any)=>{
                    if(item.children && item.children.length > 0){
                        item.children.map((i:any)=>{
                            if(i.children && i.children.length > 0){
                                i.children.map((a:any)=>{
                                    if(a.children && a.children.length > 0){

                                    }else{
                                        a.children = null;
                                    }
                                })
                            }else{
                                i.children = null;
                            }
                        })
                    }else{
                        item.children = null;
                    }
                })
                this.options = res.data.data;
            }
        })
    }
    getList(){
        let {
            source,
            status,
            isValid
        } = this.search;
        let [province='',city='',district=''] = this.selectArea;
        let url = `/api/stopArea/page?province=${province}&city=${city}&district=${district}&source=${source}&status=${status}&isValid=${isValid}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        Axios.getSecret(url).then((res:any)=>{
            if(res.data.status == 200){
                this.lastUpdateTime = res.data.data.lastUpdateTime;
                this.tableData = res.data.data.page.records || [];
                this.pageNo = Number(res.data.data.page.current);
                this.total = Number(res.data.data.page.total);
            }else{
                this.pageNo = 1;
                this.total = 0;
                this.tableData = [];
            }
        })
        
    }
    changePage(e){
        this.pageNo = e;
        this.getList();
    }
    handleSuccess(res:any,file:any,fileList:any){
        if(res.status == 124){
            this.$confirm(`上次更新时间：${res.data}`, '文件内容有效，是否替换以下数据？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let formData = new FormData();
                formData.append('file',file.raw);
                formData.append('isConfirm','true');
                Axios.formAjax({
                    url: '/api/stopArea/excelImport',
                    method: "post",
                    data: formData,
                    headers:{
                        token:this.token
                    }
                  }).then(({ data }) => {
                    this.$message({
                        type:'success',
                        message:'导入成功'
                    })
                    this.getList();
                  });
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });          
              });
        }else{
            this.$message.error(res.msg);
        }
    }
    beforeUpload(file:any){
        const isXlsx = file.name.substring(file.name.lastIndexOf(".") + 1) == 'xlsx';
        if (!isXlsx) {
            this.$message.error('上传文件只能是xlsx格式!');
        }
        return isXlsx;
    }
    onAdd(){
        this.isAdd = true;
    }
    handleClose(){
        this.isAdd = false;
        this.addForm = {
            selectArea:[]
        }
    }
    onSumbit(){
        if(this.addForm.selectArea.length === 0){
            this.$message.error('省份不可为空');
            return;
        }
        // if(this.addForm.selectArea.length === 1){
        //     this.$message.error('城市不可为空');
        //     return;
        // }
        // if(this.addForm.selectArea.length === 2){
        //     this.$message.error('区县不可为空');
        //     return;
        // }
        let data = {
            province:this.addForm.selectArea[0],
            city:this.addForm.selectArea.length > 1 ? this.addForm.selectArea[1] : '',
            district:this.addForm.selectArea.length > 2 ? this.addForm.selectArea[2] : ''
        }
        Axios.postByJson('/api/stopArea/save',data).then((res:any)=>{
            if(res.data.status == 200){
                this.$message({
                    type:'success',
                    message:'添加成功'
                })
                this.getList();
                this.handleClose();
            }else{
                this.$message.error(res.data.msg)
            }
        })
    }
    onChangeStatus(id:string,status:any){
        const STATUS_TEXT  = {
            0:'是否禁用此区域？',
            1:'是否启用此区域？',
            2:'是否删除此区域？'
        }
        this.$confirm(STATUS_TEXT[status], '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              let data = {
                id,
                status
              }
            Axios.postByJson('/api/stopArea/updateStatus',data).then((res:any)=>{
                if(res.data.status == 200){
                    this.$message({
                        type:'success',
                        message:'操作成功'
                    })
                    this.getList();
                }else{
                    this.$message.error(res.data.msg)
                }
            })
          }).catch(() => {
                this.$message({
                type: 'info',
                message: '已取消'
                });          
          });
    }
}